import axios from 'axios';
import baseURL from './setBaseUrl'
import { Message } from 'element-ui'
var i = 0;
var axiosLength = 0;
const service = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
  }
});

service.interceptors.request.use(
  (config) => {
    axiosLength = config.adapter.length
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    i++
    const res = response.data;
    if (res.code === 0) {
      return res.data;
    } else {
      if (i === axiosLength) {
        Message.error(res.msg || '未知错误')
      }
      return res.data;
    }
  },
  (error) => {
    i++
    if (i === axiosLength) {
      Message.error('未知错误')
    }
    return Promise.reject(error);
  }
);

export default service;
